import BankAccountType from "../model/BankAccountType";
import { addPresentation } from "./presentation";

export default addPresentation(BankAccountType, {
  sort: (a, b) => a.name.localeCompare(b.name),
  canAdd: true,
  canEdit: true,
  canRemove: false,
  columns: [
    { title: "Spanish Name", width: "50%", align: "left", content: { name: "spanishName" } },
    { title: "English Name", width: "50%", align: "left", content: { name: "englishName" } },
  ],
});
